import { useState } from 'react';
import {
  ErroredUploadSteps,
  UploadInspectionDataModalContext,
  UploadInspectionDataModalContextErrorState,
} from './UploadInspectionDataModalContext';
import { Steps } from '../UploadInspectionDataModal';
import {
  AtlasGqlFileFormat,
  AtlasGqlInspectionType,
  AtlasGqlMetadataFieldMapping,
} from 'types/atlas-graphql';

interface UploadInspectionDataModalContextProviderProps {
  children: React.ReactNode;
}

export function UploadInspectionDataModalContextProvider({
  children,
}: UploadInspectionDataModalContextProviderProps) {
  const [alertState, setAlertState] = useState<UploadInspectionDataModalContextErrorState | null>(
    null
  );
  const [useFolderMethod, setUseFolderMethod] = useState<boolean>(false);
  const [pendingStep, setPendingStep] = useState<Steps | undefined>();
  const [erroredUploadSteps, setErroredUploadSteps] = useState<ErroredUploadSteps>({
    summary: false,
    imageDetails: false,
  });
  const [file, setFile] = useState<File | undefined>();
  const [fieldMappings, setFieldMappings] = useState<AtlasGqlMetadataFieldMapping[] | undefined>();
  const [providedFieldNames, setProvidedFieldNames] = useState<string[]>([]);
  const [imagePathFieldName, setImagePathFieldName] = useState<string>('');
  const [previewData, setPreviewData] = useState<
    {
      [key: string]: string | number;
    }[]
  >([]);
  const [imageDetailsFileType, setImageDetailsFileType] = useState<AtlasGqlFileFormat>(
    AtlasGqlFileFormat.Csv
  );
  const [imageMissingForSomeMetadata, setImageMissingForSomeMetadata] = useState<boolean>(false);
  const [inspectionType, setInspectionType] = useState<AtlasGqlInspectionType>();
  const [createdInspectionIds, setCreatedInspectionIds] = useState<string[]>([]);
  const [createdTaskIds, setCreatedTaskIds] = useState<string[]>([]);
  const [shouldAutoRelease, setShouldAutoRelease] = useState<boolean>(true);

  const resetState = () => {
    setUseFolderMethod(false);
    setAlertState(null);
    setErroredUploadSteps({ summary: false, imageDetails: false });
    setPendingStep(undefined);
    setFile(undefined);
  };

  const contextValue = {
    alertState,
    setAlertState,
    shouldAutoRelease,
    setShouldAutoRelease,
    useFolderMethod,
    setUseFolderMethod,
    pendingStep,
    setPendingStep,
    erroredUploadSteps,
    setErroredUploadSteps,
    inspectionType,
    setInspectionType,
    createdInspectionIds,
    setCreatedInspectionIds,
    createdTaskIds,
    setCreatedTaskIds,
    imageDetailsContext: {
      file,
      setFile,
      fieldMappings,
      setFieldMappings,
      providedFieldNames,
      setProvidedFieldNames,
      imagePathFieldName,
      setImagePathFieldName,
      previewData,
      setPreviewData,
      imageDetailsFileType,
      setImageDetailsFileType,
      imageMissingForSomeMetadata,
      setImageMissingForSomeMetadata,
    },
    resetState,
  };

  return (
    <UploadInspectionDataModalContext.Provider value={contextValue}>
      {children}
    </UploadInspectionDataModalContext.Provider>
  );
}
